// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__QQqPK","filesListContainer":"PosDisputesFiles_filesListContainer__SU-3U","filesButton":"PosDisputesFiles_filesButton__2vlW-"};